var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('create-view',{on:{"create-view":_vm.addViewToProject,"cancel":_vm.cancelCreate}})}
var staticRenderFns = []

export { render, staticRenderFns }